<template>
  <div v-if="isMobile"
       ref="container"
       @touchstart="onMouseDown"
       @touchend="onMouseLeave"
       @touchcancel="onMouseLeave"
       @touchmove="onMouseMove"
  >
    <slot/>
  </div>
  <div v-else
       ref="container"
       @mousedown="onMouseDown"
       @mouseenter="onMouseEnter"
       @mouseleave="onMouseLeave"
       @mousemove="onMouseMove"
  >
    <slot/>
  </div>
</template>

<script>
import {Platform} from "../../../../utils/utils";

export default {
  name: "MobileDiv",
  data() {
    return {
      isMobile: Platform.isMobile
    }
  },
  methods: {
    addClass(className) {
      this.$refs.container.classList.add(className);
    },
    removeClass(className) {
      this.$refs.container.classList.remove(className);
    },
    onMouseDown(e) {
      this.$emit('down', e)
    },
    onMouseEnter(e) {
      this.$emit('enter', e)
    },
    onMouseLeave(e) {
      this.$emit('leave', e)
    },
    onMouseMove(e) {
      this.$emit('move', e)
    }
  }
}
</script>

<style scoped>

</style>
